import {portfolioSidebar, PortfolioSidebar} from "./PortfolioSidebarComponent";
import {whatIfGrid, WhatIfGrid} from "./what-if-grid/WhatIfGridComponent";
import {quickWhatIf, QuickWhatIf} from "./quick-what-if/QuickWhatIfPanelComponent";

export default angular.module("tfApp.portfolio.sidebar", [])
                      .component(PortfolioSidebar, portfolioSidebar())
                      .component(WhatIfGrid, whatIfGrid())
                      .component(QuickWhatIf, quickWhatIf())
                      .name;
